/* C Guides — add-to-cart on the activity-guide cards + rail dots (mobile). */
if (!customElements.get('c-guides')) {
  customElements.define(
    'c-guides',
    class CGuides extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const btn = e.target.closest('button[data-variant-id]');
          if (btn) this.add(btn);
        });
        this.setupDots();
      }

      async add(btn) {
        if (btn.disabled || btn.classList.contains('is-loading')) return;
        const status = btn.parentElement.querySelector('.c-guides__status');
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
        if (status) status.textContent = '';
        try {
          const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] }),
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Error');
          btn.textContent = btn.dataset.added;
          if (status) status.textContent = '';
          await this.refreshCartIcon();
          setTimeout(() => {
            btn.textContent = btn.dataset.label;
          }, 2500);
        } catch (err) {
          if (status) status.textContent = err.message;
        } finally {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
        }
      }

      async refreshCartIcon() {
        const current = document.getElementById('cart-icon-bubble');
        if (!current) return;
        try {
          const res = await fetch(`${window.Shopify?.routes?.root || '/'}?section_id=c-header`);
          const html = await res.text();
          const next = new DOMParser().parseFromString(html, 'text/html').getElementById('cart-icon-bubble');
          if (!next) throw new Error('no cart icon');
          current.replaceWith(next);
        } catch {
          window.location.href = this.dataset.cartUrl || '/cart';
        }
      }

      setupDots() {
        const dots = [...(this.closest('.c-guides')?.querySelectorAll('.c-guides__dot') || [])];
        const cards = [...this.querySelectorAll('.c-guides__card')];
        if (!dots.length || !cards.length) return;
        dots.forEach((dot) =>
          dot.addEventListener('click', () => {
            cards[Number(dot.dataset.index)]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          })
        );
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const i = cards.indexOf(entry.target);
              dots.forEach((d, k) => d.setAttribute('aria-current', String(k === i)));
            });
          },
          { root: this, threshold: 0.6 }
        );
        cards.forEach((c) => io.observe(c));
      }
    }
  );
}
